
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { blobDownload } from '../../../../util';
import { initClient } from '../../../../api';
import { BinQrRequest, InventoryBin, InventoryUiClient } from '../../../backend/backendapi';

@Component({
  name: 'BinPrintModal',
})
export default class BinPrintModal extends Vue {
  bins: InventoryBin[] = [];
  columns: 1 | 2 | 3 = 1;

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(bins: InventoryBin[]): void {
    this.bins = bins;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private generateQR() {
    if (!this.bins.length) {
      return;
    }

    this.service.binQr(new BinQrRequest({ columns: this.columns, binIds: this.bins.map(e => e.id) }))
        .then(response => response.data)
        .then(blob => {
          blobDownload(blob, 'qrcode.pdf');
          this.dismiss();
        });
  }
}
